// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://jfgcvujwdxhwsiwuhqkh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpmZ2N2dWp3ZHhod3Npd3VocWtoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQxNDAwMDMsImV4cCI6MjA1OTcxNjAwM30.jq2M6eALMRz281ME8Io1ErP9q-Z_1jZmQP00DVmjfjw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);